import React from "react";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";
import NestedTabsComponent from "../nested-tabs-component";
import {
  ACCESS_CONFIG,
  LEADSERVICE_PANEL_TABS,
  NESTED_SIDENAV
} from "../strings";

const LeadServicePanel = () => {
  const { t } = useTranslation();
  const { MARKETING_MANAGER_TIER } = ACCESS_CONFIG;

  return (
    <div className="d-flex h-100">
      <div className="sub-sidebar">
        <div className="inner-sub-sidebar">
          <div className="tab-heading ps-3 mt-4">LeadService Panel</div>
          <NestedTabsComponent
            nestedNavType={NESTED_SIDENAV.LEADSERVICE_PANEL}
            clearParams
            tabs={[
              {
                evKey: LEADSERVICE_PANEL_TABS.LEADSERVICE,
                title: t("leadservicePanel.leadService"),
                access: MARKETING_MANAGER_TIER
              },
              {
                evKey: LEADSERVICE_PANEL_TABS.APPOINTMENTS_PANEL,
                title: t("leadservicePanel.appointment"),
                access: MARKETING_MANAGER_TIER
              }
            ]}
          />
        </div>
      </div>
      <div className="outlet-wrapper">
        <Outlet />
      </div>
    </div>
  );
};
export default LeadServicePanel;
